<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect width="16" height="16" rx="8" fill="#31D8B0" />
    <circle cx="8" cy="8" r="3" fill="white" />
  </svg>
</template>
